/* eslint-disDigitalAssetsable react/jsx-no-constructed-context-values */
import { createContext } from 'react';

const DigitalAssetsContext = createContext({});

export default DigitalAssetsContext;
